import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ScrollButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export const ScrollButton: React.FC<ScrollButtonProps> = ({
  children,
  className = '',
  onClick
}) => {
  const checkoutUrl = 'https://tienda-1-10001.myshopify.com/checkouts/cn/hWNAQr3NwJsa0SuPUCDhl49i/es-ar?_r=AQAB71_6lH8s5n5_3gT2kf8ZrN9yZsImNxSKOxJ4M95T_VM&preview_theme_id=144578674765';
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    window.open(checkoutUrl, '_blank');
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-lg bg-brand-600 px-8 py-4 font-sans text-lg font-bold text-white shadow-md transition-all hover:bg-brand-700 hover:shadow-lg ${className}`} data-id="element-434">
      <span className="relative z-10 flex items-center gap-2" data-id="element-435">{children}</span>
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-1000 group-hover:translate-x-full" data-id="element-436" />
    </motion.button>;
};